import { useLanguage } from "../../../../stores/LanguageStore";


export function getVariables({ type, forRequired }) {
  const lang = useLanguage.getState().language
  let global = [
    {
      "label": lang.resellers.messages.variables.resellerName,
      "value": "{resellerName}",
      "name": lang.resellers.messages.variables.resellerName
    },
    {
      "label": lang.resellers.messages.variables.resellerDomainSaas,
      "value": "{resellerDomainSaas}",
      "name": lang.resellers.messages.variables.resellerDomainSaas
    },
    {
      "label": lang.resellers.messages.variables.resellerDomainApi,
      "value": "{resellerDomainApi}",
      "name": lang.resellers.messages.variables.resellerDomainApi
    },
    {
      "label": lang.resellers.messages.variables.resellerDomainFiles,
      "value": "{resellerDomainFiles}",
      "name": lang.resellers.messages.variables.resellerDomainFiles
    },
    {
      "label": lang.resellers.messages.variables.resellerDomainRedirect,
      "value": "{resellerDomainRedirect}",
      "name": lang.resellers.messages.variables.resellerDomainRedirect
    }
  ];

  let v = {
    "MailTestSmtpCredentials": [
    ],
    "MailValidationMassMailing": [
      {
        "label": lang.resellers.messages.variables.validateUrl,
        "value": "{validateUrl}",
        "name": lang.resellers.messages.variables.validateUrl,
        "required": true
      }
    ],
    "MailValidationMail": [
      {
        "label": lang.resellers.messages.variables.validateUrl,
        "value": "{validateUrl}",
        "name": lang.resellers.messages.variables.validateUrl,
        "required": true
      }
    ],
    "MailDisconnectedAPIEmailAccount": [
      {
        "label": lang.resellers.messages.variables.emailAccount,
        "value": "{emailAccount}",
        "name": lang.resellers.messages.variables.emailAccount,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.reconnectUrl,
        "value": "{reconnectUrl}",
        "name": lang.resellers.messages.variables.reconnectUrl,
        "required": true
      }
    ],
    "LinkedinDisconnected": [
      {
        "label": lang.resellers.messages.variables.linkedinAccountName,
        "value": "{linkedinAccountName}",
        "name": lang.resellers.messages.variables.linkedinAccountName,
        "required": true
      }
    ],
    "OrganizationJoin": [
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.organizationName,
        "value": "{organizationName}",
        "name": lang.resellers.messages.variables.organizationName,
        "required": true
      }
    ],
    "TeamJoin": [
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.teamName,
        "value": "{teamName}",
        "name": lang.resellers.messages.variables.teamName,
        "required": true
      }
    ],
    "PasswordResetEmail": [
      {
        "label": lang.resellers.messages.variables.resetCode,
        "value": "{resetCode}",
        "name": lang.resellers.messages.variables.resetCode,
        "required": true
      }
    ],
    "AccountLocked": [
      {
        "label": lang.resellers.messages.variables.unlockCode,
        "value": "{unlockCode}",
        "name": lang.resellers.messages.variables.unlockCode,
        "required": true
      }
    ],
    "InviteUserOrganization": [
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.organizationName,
        "value": "{organizationName}",
        "name": lang.resellers.messages.variables.organizationName,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.joinUrl,
        "value": "{joinUrl}",
        "name": lang.resellers.messages.variables.joinUrl,
        "required": true
      }
    ],
    "InviteUserTeam": [
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.teamName,
        "value": "{teamName}",
        "name": lang.resellers.messages.variables.teamName,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.joinUrl,
        "value": "{joinUrl}",
        "name": lang.resellers.messages.variables.joinUrl,
        "required": true
      }
    ],
    "PositiveReply": [
      {
        "label": lang.resellers.messages.variables.replyURL,
        "value": "{replyURL}",
        "name": lang.resellers.messages.variables.replyURL,
      },
      {
        "label": lang.resellers.messages.variables.fullName,
        "value": "{fullName}",
        "name": lang.resellers.messages.variables.fullName,
      },
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
      },
    ],
    "NegativeReply": [
      {
        "label": lang.resellers.messages.variables.replyURL,
        "value": "{replyURL}",
        "name": lang.resellers.messages.variables.replyURL,
      },
      {
        "label": lang.resellers.messages.variables.fullName,
        "value": "{fullName}",
        "name": lang.resellers.messages.variables.fullName,
      },
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
      },
    ],
    "NeutralReply": [
      {
        "label": lang.resellers.messages.variables.replyURL,
        "value": "{replyURL}",
        "name": lang.resellers.messages.variables.replyURL,
      },
      {
        "label": lang.resellers.messages.variables.fullName,
        "value": "{fullName}",
        "name": lang.resellers.messages.variables.fullName,
      },
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
      },
    ],
    "PrmColumnEntryInstant": [
      {
        "label": lang.resellers.messages.variables.contactId,
        "value": "{contactId}",
        "name": lang.resellers.messages.variables.contactId,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.contactDetails,
        "value": "{contactDetails}",
        "name": lang.resellers.messages.variables.contactDetails,
        "required": false
      },
      {
        "label": lang.resellers.messages.variables.columnLabel,
        "value": "{columnLabel}",
        "name": lang.resellers.messages.variables.columnLabel,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.profileURL,
        "value": "{profileURL}",
        "name": lang.resellers.messages.variables.profileURL,
        "required": false
      },
    ],
    "PrmColumnEntryDailyDigest": [
      {
        "label": lang.resellers.messages.variables.digestDate,
        "value": "{digestDate}",
        "name": lang.resellers.messages.variables.digestDate,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.tableHtml,
        "value": "{tableHtml}",
        "name": lang.resellers.messages.variables.tableHtml,
        "required": true
      },
      {
        "label": lang.resellers.messages.variables.userName,
        "value": "{userName}",
        "name": lang.resellers.messages.variables.userName,
      },
    ],
  }

  if (forRequired) {
    return v[type] ? v[type].filter(x => x.required) : []
  }

  return [...v[type], ...global]
}